import _ from 'lodash';
import IConditionSuggestion from '~Api/LoanDrawdowns/IConditionSuggestion';
import ILoanDrawdownCondition from '~Api/LoanDrawdowns/ILoanDrawdownCondition';
import ILoanDrawdownConditionDocument from '~Api/LoanDrawdowns/ILoanDrawdownConditionDocument';
import { IGlobalState } from '~reducer';
import { IDictionary } from '~utilities/IDictionary';
import { keyMap } from '~utilities/utils';

export function loanDrawdownConditionsWithDocumentsSelector(state: IGlobalState, drawdownUuid: string): IDictionary<ILoanDrawdownCondition> {
    if (!state.loanDrawdowns.loanDrawdownConditionsListed[drawdownUuid] || !state.loanDrawdowns.loanDrawdownConditionDocumentsListed[drawdownUuid]) {
        return null;
    }

    return keyMap(state.loanDrawdowns.loanDrawdownConditionUuids[drawdownUuid], 'uuid', (conditionUuid: string): ILoanDrawdownCondition => {
        return loanDrawdownConditionSelector(state, conditionUuid);
    });
}

export function loanDrawdownConditionDocumentsSelector(state: IGlobalState, conditionUuid: string): IDictionary<ILoanDrawdownConditionDocument> {
    if (!state.loanDrawdowns.loanDrawdownConditionDocumentUuids[conditionUuid]) {
        return null;
    }

    return keyMap(state.loanDrawdowns.loanDrawdownConditionDocumentUuids[conditionUuid], 'uuid', (conditionDocumentUuid: string): ILoanDrawdownConditionDocument => {
        return state.loanDrawdowns.drawdownConditionDocuments[conditionDocumentUuid];
    });
}

export function loanDrawdownConditionSelector(state: IGlobalState, conditionUuid: string): ILoanDrawdownCondition {
    return {
        ...state.loanDrawdowns.drawdownConditions[conditionUuid],
        documents: _.values(loanDrawdownConditionDocumentsSelector(state, conditionUuid)),
    };
}

export function loanDrawdownConditionSuggestionsSelector(state: IGlobalState, drawdownUuid: string): IConditionSuggestion[] {
    return state.loanDrawdowns.conditionSuggestions[drawdownUuid];
}
